import Component from 'inferno-component';
import Page from '../components/Page';
import '../assets/styles/index.css';
const kailoaLogo = require('../assets/images/kailoa-logo.png');
const kamakauLogo = require('../assets/images/kamakau-logo.png');

class Mission extends Component {
  render() {
    return (
      <Page title="Mission">
        <div className="about__container">
          <h2 className="about__header">
            About KAI LOA, Inc. and Ke Kula ʻo Samuel M. Kamakau, Laboratory
            Public Charter School
          </h2>
          <div className="about__body">

            <p>
              The mission of KAI LOA, Inc. is to help ensure the
              quality and long-term success {' '}
              <img className="about__logo__kailoa" src={kailoaLogo} />
              of Ke Kula ʻo Samuel M. Kamakau, Laboratory Public Charter School (LPCS), a Preschool-Grade 12 Hawaiian Immersion laboratory public charter school located in lush Haʻikū, Oʻahu. KAI LOA supports Kamakau and fulfills its
              mission by focusing on three major goals:
            </p>
            <ul>
              <li>
                Build capacity for the school’s increasing number of qualified teachers and support personnel and strengthen the school’s curriculum to meet the growing needs of its students.
              </li>
              <li>
                Develop and maintain a planned approach to financial growth to ensure a sustainable source of income.
              </li>
              <li>
                Promote parent and community involvement as stakeholders in the school’s success.
              </li>
            </ul>
            <p>
              Ke Kula ‘o Samuel M. Kamakau Laboratory Public
              Charter School is a family-based, {' '}
              <img className="about__logo__kamakau" src={kamakauLogo} />
              Hawaiian language medium school offering a comprehensive multi-level (PK through Secondary) educational program. Ke Kula ‘o Kamakau was initially established
              in January 2000 in response to the expressed needs of Native
              Hawaiian families to increase student achievement through
              culture-based education while addressing the educational needs of
              multi-generations of learners. As an indigenous language
              laboratory school program, Ke Kula ‘o Kamakau is committed to the
              ongoing development of Hawaiian language education through
              research, teacher training, and resource development.{' '}
            </p>

            <p>
              We are honored to carry the name of Samuel Mānaiakalani Kamakau
              (1815-1876), who was a noted Native Hawaiian scholar, genealogist,
              historian, teacher and legislator renown for chronicling the
              ancient, traditional cultural and history of the Hawaiian people.
              His life symbolizes integral qualities that we as contemporary
              Native Hawaiians can aspire to: his life-long love of learning,
              his deep knowledge of culture and history, and his untiring quest
              to preserve the past for future generations.{' '}
            </p>
            <div className="about__donate">
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_s-xclick"/>
                <input type="hidden" name="hosted_button_id" value="ECAERDDMK8G58"/>
                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!"/>
                <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1"></img>
              </form>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

export default Mission;



// WEBPACK FOOTER //
// ./src/pages/Mission.js